<template>
  <div class="string-list-field">
    <label class="string-list-field__label">
      <span>{{ label }}</span>
    </label>

    <div v-if="hint" class="string-list-field__hint">
      {{ hint }}
    </div>

    <draggable
      v-model="rows"
      handle=".string-list-field__drag"
      :disabled="disabled || loading"
      ghost-class="string-list-field__row_ghost"
      @end="sync"
    >
      <div
        v-for="(row, index) in rows"
        :key="row.key"
        class="string-list-field__row"
      >
        <v-icon
          class="string-list-field__drag"
          :class="{ 'string-list-field__drag_disabled': disabled || loading }"
        >
          mdi-drag-vertical
        </v-icon>

        <v-text-field
          v-model="row.text"
          :disabled="disabled"
          :loading="loading"
          outlined
          dense
          hide-details
          @input="sync"
        />

        <div class="string-list-field__actions">
          <v-btn
            icon
            :disabled="disabled"
            @click="remove(index)"
          >
            <v-icon color="#EB5757">
              mdi-trash-can-outline
            </v-icon>
          </v-btn>
        </div>
      </div>
    </draggable>

    <div v-if="!rows.length" class="string-list-field__empty">
      {{ emptyText }}
    </div>

    <v-btn
      class="string-list-field__add"
      type="button"
      text
      :disabled="disabled || loading"
      @click.stop="add"
    >
      <v-icon left>
        mdi-plus
      </v-icon>
      {{ addText }}
    </v-btn>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'

  export default {
    name: 'StringListField',
    components: { draggable },
    props: {
      value: {
        type: Array,
        default: () => [],
      },
      label: {
        type: String,
        default: 'Список',
      },
      itemLabel: {
        type: String,
        default: 'Пункт',
      },
      addText: {
        type: String,
        default: 'Добавить пункт',
      },
      emptyText: {
        type: String,
        default: 'Пока ничего не добавлено',
      },
      hint: {
        type: String,
        default: null,
      },
      loading: Boolean,
      disabled: Boolean,
    },
    data () {
      return {
        rows: [],
        nextKey: 0,
      }
    },
    computed: {
      // Наружу отдаём только заполненные строки: пустая нужна в вёрстке, пока её набирают
      filled () {
        return this.rows.map((row) => row.text.trim()).filter(Boolean)
      },
    },
    watch: {
      value: {
        immediate: true,
        handler (next) {
          const incoming = Array.isArray(next) ? next : []

          // Своё же значение, вернувшееся через v-model, строки не пересоздаёт — иначе теряется фокус
          if (JSON.stringify(incoming) === JSON.stringify(this.filled)) return

          this.rows = incoming.map((text) => ({ key: this.nextKey++, text }))
        },
      },
    },
    methods: {
      add () {
        this.rows.push({ key: this.nextKey++, text: '' })
      },
      remove (index) {
        this.rows.splice(index, 1)
        this.sync()
      },
      sync () {
        this.$emit('input', this.filled)
      },
    },
  }
</script>

<style lang="less" scoped>
.string-list-field {
  position: relative;
  margin-bottom: 30px;
  padding: 24px 20px 12px;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;

  &__label {
    position: absolute;
    top: 11px;
    left: -12px;
    padding: 0 5px;
    background: #fff;
    color: #999;
    font-size: 16px;
    transform: translateY(-24px) scale(0.75);
  }

  &__hint {
    margin-bottom: 12px;
    font-size: 12px;
    color: #949191;
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    background: #fff;

    &_ghost {
      opacity: 0.4;
      background: #f5f5f5;
    }
  }

  &__drag {
    flex: 0 0 auto;
    cursor: grab;

    &:active {
      cursor: grabbing;
    }

    &_disabled {
      cursor: default;
      opacity: 0.4;
    }
  }

  &__actions {
    display: flex;
    flex: 0 0 auto;
    gap: 2px;
  }

  &__empty {
    margin-bottom: 10px;
    font-size: 13px;
    color: #949191;
  }

  &__add.v-btn {
    text-transform: none;
    letter-spacing: normal;
  }
}
</style>
